import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { EditAssumptionComponent } from '../../dialogue/edit-assumption/edit-assumption.component';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { UserService } from 'src/app/core/services/user.service';
import { UtilService } from 'src/app/core/services/util.service';

@Component({
  selector: 'app-site-assumptions',
  templateUrl: './site-assumptions.component.html',
  styleUrls: ['./site-assumptions.component.scss']
})
export class SiteAssumptionsComponent implements OnInit {
  @Input() assumptionData: any;
  @Input() siteData: any;
  @Output() reloadAssumption = new EventEmitter<boolean>();
  public source: string = '';

  constructor(private modalService: NgbModal, public userService: UserService, private util: UtilService) { }

  ngOnInit(): void {
    this.source = this.util.source;
  }

  openEditAssumptionModal(): void {
    const modalRef = this.modalService.open(EditAssumptionComponent, {size: 'lg'})
    modalRef.componentInstance.assumptionData = this.assumptionData;
    modalRef.componentInstance.siteData = this.siteData;
    modalRef.componentInstance.onClose.subscribe((resp: boolean) => {
      if(resp){
        this.reloadAssumption.emit(true)
      }
    })
  }

}
